import type { FC } from 'react';

import { SkeletonBlock } from '../../ui/SkeletonBlock';

export const PostAuthorHeaderSkeleton: FC = () => (
  <div className="flex flex-1 items-center gap-4 min-w-0">
    <SkeletonBlock className="size-10 !rounded-full shrink-0" />
    <div className="flex items-center gap-[6px]">
      <SkeletonBlock className="w-[90px] h-[18px]" />
      <SkeletonBlock className="w-[25px] h-[18px]" />
      <SkeletonBlock className="w-[77px] h-[18px]" />
    </div>
  </div>
);
